export const DEFAULT_TITLE = 'Alloy: An API to Know Your Customers';
export const SPA_PREFIX = '/v3/dashboard';

export enum ResetPasswordViewMode {
  RESETPW = 'reset-password',
  SETPW = 'set-password',
}

export enum ValidateEmailMode {
  VALIDATEEMAIL = 'validate-email',
  VALIDATECUSTOMEREMAIL = 'validate-customer-email',
}
